import * as rq from '@tanstack/react-query';

import { useDependencies } from '@/api/fe-api/contexts/dependencies.context';
import type { IAIRepository } from '@/api/fe-api/domain/repositories/ai-respository';

export namespace GetChatHistory {
  export const key = (): string[] => ['ai', 'get-chat-history'];

  export type Output = IAIRepository.GetChatHistoryOutput;

  export function useQuery() {
    const { repositories } = useDependencies();

    return rq.useQuery({
      queryKey: key(),
      enabled: false,
      queryFn: () => repositories.ai.getChatHistory(),
    });
  }
}
